import { addMonths, format, parseISO } from "date-fns";

/** `YYYY-MM` moved by whole months. */
export const monthAfter = (month: string, by = 1) =>
  format(addMonths(parseISO(`${month}-01`), by), "yyyy-MM");

/** "September 2026", or "September" with `short`. */
export const monthName = (month: string, short = false) =>
  format(parseISO(`${month}-01`), short ? "MMMM" : "MMMM yyyy");

/** "5 Oct 2026", or "Tue 1 Sep" with `weekday`, for a stored instant on the company's day. */
export function dayOf(iso: string, timeZone: string, weekday = false) {
  // en-CA spells the date as YYYY-MM-DD.
  const day = new Intl.DateTimeFormat("en-CA", { timeZone }).format(
    new Date(iso),
  );
  return format(parseISO(day), weekday ? "EEE d MMM" : "d MMM yyyy");
}

/** "28 Oct", for a `YYYY-MM-DD` day. */
export const shortDay = (day: string) => format(parseISO(day), "d MMM");
